export const COVERED_STATE_FETCH_REQUEST = `COVERED_STATE_FETCH_REQUEST`;
export const COVERED_STATE_FETCH_SUCCESS = `COVERED_STATE_FETCH_SUCCESS`;
export const COVERED_STATE_FETCH_FAILURE = `COVERED_STATE_FETCH_FAILURE`;

// license table

export const LICENSETABLE_FETCH_REQUEST = `LICENSETABLE_FETCH_REQUEST`;
export const LICENSETABLE_FETCH_SUCCESS = `LICENSETABLE_FETCH_SUCCESS`;
export const LICENSETABLE_FETCH_FAILURE = `LICENSETABLE_FETCH_FAILURE`;

// add to the table

export const LICENSETABLE_ADD_REQUEST = `LICENSETABLE_ADD_REQUEST`;
export const LICENSETABLE_ADD_SUCCESS = `LICENSETABLE_ADD_SUCCESS`;
export const LICENSETABLE_ADD_FAILURE = `LICENSETABLE_ADD_FAILURE`;

// delete

export const LICENSETABLE_DELETE_REQUEST = `LICENSETABLE_DELETE_REQUEST`;
export const LICENSETABLE_DELETE_SUCCESS = `LICENSETABLE_DELETE_SUCCESS`;
export const LICENSETABLE_DELETE_FAILURE = `LICENSETABLE_DELETE_FAILURE`;

// edit

export const LICENSETABLE_EDIT_REQUEST = `LICENSETABLE_EDIT_REQUEST`;
export const LICENSETABLE_EDIT_SUCCESS = `LICENSETABLE_EDIT_SUCCESS`;
export const LICENSETABLE_EDIT_FAILURE = `LICENSETABLE_EDIT_FAILURE`;



// WEBPACK FOOTER //
// ./src/views/state/MyInfoSettings/types.js